package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.icons.fa.FaBold
import com.varabyte.kobweb.silk.components.icons.fa.FaItalic
import com.varabyte.kobweb.silk.components.icons.fa.FaListOl
import com.varabyte.kobweb.silk.components.icons.fa.FaListUl
import com.varabyte.kobweb.silk.components.icons.fa.FaUnderline
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.ToolbarIconContainerStyle
import io.horion.cv.styles.ToolbarIconInnerStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun ToolbarIcon(
    src: String,
    description: String,
    isActive: Boolean = false,
    onClick: () -> Unit,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val iconColor = when {
        isActive -> Colors.Blue
        isDark -> Colors.White
        else -> Colors.Black
    }

    val bgColor = when {
        isActive && isDark -> Colors.holder
        isActive && !isDark -> Colors.LightGray
        else -> null
    }

    Box(
        modifier = ToolbarIconContainerStyle.toModifier()
            .cursor(Cursor.Pointer)
            .borderRadius(5.px)
            .border(
                width = if (isActive) 1.px else 0.px,
                style = if (isActive) LineStyle.Solid else LineStyle.None,
                color = if (isActive) Colors.Blue else Colors.Graytext
            )
            .then(if (bgColor != null) Modifier.backgroundColor(bgColor) else Modifier)
            .onClick { onClick() },
        contentAlignment = Alignment.Center
    ) {
        val iconModifier = ToolbarIconInnerStyle.toModifier()
            .color(iconColor)

        when {
            src.contains("bold") -> FaBold(modifier = iconModifier)
            src.contains("italic") -> FaItalic(modifier = iconModifier)
            src.contains("underline") -> FaUnderline(modifier = iconModifier)
            src.contains("list-bullet") -> FaListUl(modifier = iconModifier)
            src.contains("list-number") -> FaListOl(modifier = iconModifier)
            else -> FaBold(modifier = iconModifier)
        }
    }
}